import PropTypes from 'prop-types';

import BrSelect from '@components/BrSelect';

const PerPageOptionComponent = function ({ selectedOption, perPageOptions, onChangeNumPerPage, displayText }) {
  const dropdownItems = perPageOptions.map((option) => {
    return { title: option.toString(), value: option };
  });
  return (
    <div className="paginator-perpage-option">
      <span className="rows-text">{displayText || 'Rows Per Page'}</span>
      <BrSelect options={dropdownItems} onSelect={onChangeNumPerPage} selected={selectedOption} />
    </div>
  );
};

PerPageOptionComponent.propTypes = {
  selectedOption: PropTypes.number.isRequired,
  perPageOptions: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChangeNumPerPage: PropTypes.func.isRequired,
};

export default PerPageOptionComponent;
